
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import creditServices from '@/services/credit-services';
import { eventBus } from '@/main';
import commonServices from '@/services/common-services';
const numeral = require('numeral');
@Component({
    components: {
        Loading
    }
})
export default class Recharge extends Vue {
  private bankInfos: any = [];
  private bankInfo = {
    'BankName': '',
    'Owner': '',
    'CardNumber': ''
  }

  @Prop({ default: null })
  private onRecharge!: boolean;

  private isLoading = false;
  private rechargeModel = {
    rechargeValue: 0,
    bankId: 0,
    tradeContent: ''
  };
  get userInfo() {
    return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
  }
  get rechargeMethods() {
    return DATA.rechargeMethods;
  }

  get qrLink() {
    return `https://api.vietqr.io/image/${this.bankInfo.BankName}-${this.bankInfo.CardNumber}-Yn8aW0x.jpg?addInfo=NAP${this.userInfo.userId}&accountName=${this.bankInfo.Owner}`;
  }

  @Watch('onRecharge', { immediate: true, deep: true })
  private watchOnRecharge() {
    this.recharge();
  }

  private async recharge() {
    try {
      const isValid = await (this.$refs['observer'] as any).validate();
      if (isValid) {

        this.isLoading = true;

        const dataRequest = {
          Amount: numeral(this.rechargeModel.rechargeValue).value(),
          Method: this.rechargeModel.bankId,
          UID: this.userInfo.userId,
          Username: this.userInfo.userName,
          TradeContent: this.rechargeModel.tradeContent
        };

        const result = await creditServices.submitRecharge(dataRequest);

        if (
          result &&
          result.status === 200 &&
          result.data.message === 'Success'
        ) {
          Vue.notify({
            group: 'foo',
            type: 'success',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thành công!',
          });
          this.rechargeModel = {
            rechargeValue: 0,
            bankId: 0,
            tradeContent: ''
          };
          eventBus.$emit(APP_CONFIG.eventBusAction.reloadWithdrawalHistories);
        } else {
          Vue.notify({
            group: 'foo',
            type: 'error',
            title: 'Thông báo!',
            text: 'Tạo lệnh nạp tiền thất bại!',
          });
        }
        this.isLoading = false;
      }
    } catch {
      return false;
    }
  }

  private async created() {
    const result = await commonServices.getBankInfo();
    if (
      result &&
      result.status === 200 &&
      result.data.message === 'Success'
    ) {
      this.bankInfos = result.data.data;
    }
  }
}
